angular.module('impactx.login').controller('LoginOciCtrl', LoginOciCtrl);

LoginOciCtrl.$inject = ['LoginService', '$securityManager', '$routeParams', 'dataGen'];

function LoginOciCtrl(LoginService, $securityManager, $routeParams, dataGen) {
    var token = $routeParams.token;
    $securityManager.setToken(token);
    dataGen.getData({}, {}, "/prepareexternallogin").then(function() {
        LoginService.refreshUI(true);
    });
}
